import { BASEURL } from '../Constants';

const request = async (path, { method = 'GET', body } = {}) => {
  const token = sessionStorage.getItem('token');
  if (!token) {
    const error = new Error('Authentication is required.');
    error.code = 'AUTH_REQUIRED';
    throw error;
  }

  const response = await fetch(`${BASEURL}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok || data?.error === 1 || data?.error === true) {
    const error = new Error(data?.message || `Account settings request failed (${response.status}).`);
    error.status = response.status;
    error.payload = data;
    throw error;
  }

  return data;
};

export const getMfaSettings = () => request('/user/mfa');

export const updateMfaSettings = (enabled, password) => request('/user/mfa', {
  method: 'PUT',
  body: { enabled, password },
});
